/**
 * CommentsSection — Instructions step (Wave 4 native).
 *
 * Free-form textarea writing directly into `instructionsSlice.comments`.
 * Parent owns the controlled value. Reused ~verbatim from the pre-revert
 * native module (`a8d9ef9f4^`).
 */

import React from 'react'
import { useTranslation } from 'react-i18next'

import { MUIInputField } from 'components/common/MUIInputField'
import { SectionedBorderBox } from 'components/common/SectionedBorderBox'


interface Props {
  value: string | undefined
  onChange: (next: string | undefined) => void
  /**
   * A creative will attend the shoot, so the box is a briefing for them and
   * carries legacy's photographer label + matching-algorithm caveat.
   * Orders nobody attends keep the neutral framing.
   */
  isCreativeBriefing?: boolean
  /** The client is choosing their creative, so the "matching is done by algorithm" caveat would be false. */
  isChoosingCreative?: boolean
}

export const CommentsSection: React.FC<Props> = ({ value, onChange, isCreativeBriefing = false, isChoosingCreative = false }) => {
  const { t } = useTranslation(['purchase_flow_revamp'])

  return (
    <SectionedBorderBox variant="flat"
      title={t('purchase_flow_revamp:instructions.comments.section_title')}
      description={t('purchase_flow_revamp:instructions.comments.section_description')}
    >
      <MUIInputField
        isMultiline
        inputBoxHeight="10rem"
        label={isCreativeBriefing ? t('purchase_flow_revamp:instructions.comments.label') : undefined}
        hintText={isCreativeBriefing && !isChoosingCreative ? t('purchase_flow_revamp:instructions.comments.field_note') : undefined}
        placeholder={t('purchase_flow_revamp:instructions.comments.placeholder')}
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value || undefined)}
      />
    </SectionedBorderBox>
  )
}
